import Cookies from "js-cookie";

const TokenKey = "User-Token";
const RefreshToken = "Refresh-Token";
const TokenType = "Token-Type";
const UserInfo = "User-Info";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { secure: true });
}
export function setUser(user) {
  return Cookies.set(UserInfo, user, { secure: true });
}
export function getUser() {
  return Cookies.get(UserInfo);
}
export function setRefreshToken(token) {
  return Cookies.set(RefreshToken, token, { secure: true });
}

export function getRefreshToken() {
  return Cookies.get(RefreshToken);
}

export function getToken_type() {
  return Cookies.get(TokenType);
}

export function setToken_type(token_type) {
  return Cookies.set(TokenType, token_type, { secure: true });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
